import { render, staticRenderFns } from "./AddAntiPassBack.vue?vue&type=template&id=9642a15c"
import script from "./AddAntiPassBack.vue?vue&type=script&lang=js"
export * from "./AddAntiPassBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports